import { getQueryStringParameter } from '../../../helpers';
import { phoneNumberFormatter } from '../../../phoneNumberFormatter'

const initClientIdStep = () => {
  const $form = $('form#legal-profile-form');
  const step = getQueryStringParameter('id');

  if (
    $form.length === 0
    || (step !== null && step !== '' && step !== 'client_id' && !window.location.pathname.endsWith('new'))
  ) {
    return;
  }

  if ($form.data('client-id-initialized')) return;
  $form.data('client-id-initialized', true);

  const secondSignatoryRadios = $form[0].querySelectorAll('input[name="users_profile_legal[has_second_signatory]"]');
  const secondSignatorySection = $form[0].querySelector('#second_signatory_section');

  if (secondSignatoryRadios.length > 0 && secondSignatorySection) {
    secondSignatoryRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.value === 'true') {
          secondSignatorySection.classList.remove('d-none');
        } else {
          secondSignatorySection.classList.add('d-none');
        }
      });
    });
  }

  const phoneNumberInput = $form[0].querySelector('#phone_number_input');
  const phoneNumberErrorMesage = $form[0].querySelector('#phone_number_error_message');

  if (phoneNumberInput) {
    phoneNumberFormatter(phoneNumberInput, phoneNumberErrorMesage);
  }

  const secondSignatoryPhoneInput = $form[0].querySelector('#second_signatory_phone_number_input');
  const secondSignatoryPhoneErrorMessage = $form[0].querySelector('#second_signatory_phone_number_error_message');

  if (secondSignatoryPhoneInput) {
    phoneNumberFormatter(secondSignatoryPhoneInput, secondSignatoryPhoneErrorMessage);
  }
};

$(initClientIdStep);
document.addEventListener('turbo:load', initClientIdStep);
